var isMobile = window.innerWidth <= 767;
var modelSwiperVar = null;
var modelSwiper = null;

var currentModel = [];
var next_active_model = null;
var swierActiveSlide = {model_active: 0, strap_active: 0};
var price_element = null;
var spin_items = document.querySelectorAll('.wrap_loading_img');
for (var i = 0; i < spin_items.length; i++) {
  spin_items[i].addEventListener('click', function () {
    swierActiveSlide = {model_active: 0, strap_active: 0};
    var item = this;
    if (!this.classList.contains('item_spin_li')) {
      item = this.closest('.item_spin_li');
    }

    var next_model = item.dataset.mtype;
    var next_slide = item.dataset.sslider;

    var model_title = item.dataset.nexttitle;
    document.querySelector('.builder-heading').innerText = model_title;
    document.querySelector('.builder-heading').innerText =
      document.querySelector('.model_step_content').dataset.title;
    var next_model_content = item.dataset.nextm;
    var all_builder = this.closest('.builder');
    all_builder.querySelector('.wrap_swipe_item').style.display = 'block';
    next_active_model = document.querySelector('.' + next_model_content);
    var current_select_img = next_active_model.querySelector(
      '.current_selection_img img'
    );
    this.closest('.spin_step_content').style.display = 'none';
    this.closest('.spin_step_content').classList.remove('active');
    document.querySelector('.progress').style.width = isMobile ? '25%' : '29%';
    modelSlider(next_slide);

    setTimeout(function () {
      all_builder.querySelector('.wrap_swipe_item').style.display = 'none';
    }, 5000);

    setTimeout(function () {
      all_builder.querySelector('.model_step_content').style.display = 'block';
      all_builder.querySelector('.model_step_content').classList.add('active');
      next_active_model.style.display = 'block';
      next_active_model.classList.add('active');

      all_builder.querySelector('.model_step').classList.add('active');
      modelSlider(next_slide);
      var title = next_active_model.querySelector('.model_slide:first-of-type')
        .dataset.title;
      var image = next_active_model.querySelector('.model_slide:first-of-type')
        .dataset.image;
      document.querySelector('.builder-subheading').innerText = title;

      current_select_img.src = image;

      var small_item = document.querySelector('.content_step.active');
      small_item.querySelector('.wrap_loading_title_sub h2').innerText =
        next_active_model.querySelector(
          '.model_slide:first-of-type'
        ).dataset.subtitle;
      small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
        next_active_model.querySelector(
          '.model_slide:first-of-type'
        ).dataset.pdeter;
      price_element = next_active_model.querySelector(
        '.model_slide:first-of-type'
      ).dataset.pdeter;

      currentModel = [
        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .idproduct,

        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .subtitle,
        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .price,
        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .fimage,
        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .urlproduct,
        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .metafiled1,
        next_active_model.querySelector('.model_slide:first-of-type').dataset
          .metafiled2,
      ];

      var prevstep = all_builder.querySelector('.prev_step');
      prevstep.dataset.currents = next_model;
      prevstep.dataset.currentslide = 'swiper_slide_' + next_model;

      var nextstep = all_builder.querySelector('.next_step');
      nextstep.dataset.currentslide = 'swiper_slide_' + next_model;
      nextstep.dataset.currents = next_model;
      if (nextstep.dataset.nexts == 'strap') {
        nextstep.setAttribute(
          'data-nextstep',
          next_active_model.querySelector('.model_slide:first-of-type').dataset
            .strapstep
        );
        nextstep.setAttribute(
          'data-nextslide',
          'swiper_' +
            next_active_model.querySelector('.model_slide:first-of-type')
              .dataset.strapstep +
            '_' +
            next_active_model.querySelector('.model_slide:first-of-type')
              .dataset.currents
        );
      }

      // $(".current-selection img").attr("data-src", currentModel[0]).attr("src", currentModel[0]);
      //$(".builder-subheading").text(currentModel[1]);
    }, 1000);
  });
}

function modelSlider(slide_id) {
  modelSwiper = new Swiper('#' + slide_id, {
    direction: 'horizontal',
    loop: false,
    slidesPerView: 2,
    centeredSlides: true,
    grabCursor: true,

    slideToClickedSlide: true,
    cssMode: true,
    breakpoints: {
      768: {
        slidesPerView: 3,
        cssMode: false,
      },
    },
    keyboard: {
      enabled: true,
      onlyInViewport: true,
    },
    scrollbar: {
      el: '.swiper-scrollbar',
      draggable: false,
    },
  });
  modelSwiperVar = modelSwiper;

  var active_wrapper_model = document
    .querySelector('#' + slide_id)
    .closest('.content_step');
  if (
    active_wrapper_model
      .querySelector('.model_slide:first-of-type')
      .classList.contains('strap_slide')
  ) {
    var swrap = document.querySelector('#' + slide_id);
    var title = swrap.querySelector('.strap_slide:first-of-type').dataset.title;
    title +=
      ' | ' + swrap.querySelector('.strap_slide:first-of-type').dataset.name;

    document.querySelector('.builder-subheading').innerText = title;
  }

  if (
    slide_id == 'swiper_slide_non_spin' ||
    slide_id == 'swiper_slide_spin' ||
    slide_id == 'swiper_slide_pocket' ||
    slide_id == 'swiper_slide_autom'
  ) {
    modelSwiper.slideTo(swierActiveSlide.model_active, 500);
  } else {
    modelSwiper.slideTo(swierActiveSlide.strap_active, 500);
  }

  loading_on_slider_change(modelSwiper, active_wrapper_model);
  modelSwiperVar = modelSwiper;
  return modelSwiper;
}

var prev_steps = document.querySelectorAll('.prev_step');
for (var i = 0; i < prev_steps.length; i++) {
  prev_steps[i].addEventListener('click', function () {
    console.log(swierActiveSlide);
    var prevstep = this.dataset.prevstep;

    var current_step = this.dataset.currentstep;
    var ptype = this.dataset.currents;
    header_steps_style(current_step, 'prev');

    if (this.dataset.currentstep == 'model') {
      loading_destory_slider(this.dataset.currentslide);

      style_wrapper_content(
        this.closest('.content_step'),
        current_step,
        prevstep,
        ptype,
        'prev'
      );

      //document.querySelector('.wrap_swipe_item').style.display = 'block';

      /* setTimeout(function () {
        document.querySelector('.wrap_swipe_item').style.display = 'none';
      }, 6000); */
    }
    if (this.dataset.currentstep == 'strap') {
      loading_destory_slider(this.dataset.currentslide);

      style_wrapper_content(
        this.closest('.content_step'),
        current_step,
        'model',
        ptype,
        'prev'
      );
      modelSlider(this.dataset.prevslide);
      loading_setup_slider(this.dataset.prevslide, this.dataset.currentstep);
      document.querySelector('.wrap_swipe_item').style.display = 'block';

      setTimeout(function () {
        document.querySelector('.wrap_swipe_item').style.display = 'none';
      }, 6000);
    }
    if (this.dataset.currentstep == 'add_tocart') {
      document.querySelector('.wrap_swipe_item').style.display = 'block';

      setTimeout(function () {
        document.querySelector('.wrap_swipe_item').style.display = 'none';
      }, 5000);

      // loading_destory_slider(this.dataset.currentslide);

      style_wrapper_content(
        this.closest('.content_step'),
        current_step,
        'strap',
        null,
        'prev'
      );
      modelSlider(this.dataset.prevslide);
      loading_setup_slider(this.dataset.prevslide, 'strap', 'addtocart');
      strap_inner_product(this.dataset.newprevstep);
    }
  });
}

var next_steps = document.querySelectorAll('.next_step');
for (var i = 0; i < next_steps.length; i++) {
  next_steps[i].addEventListener('click', function () {
    console.log(swierActiveSlide);
    var nextstep = this.dataset.nextstep;
    var current_step = this.dataset.currentstep;
    var nexts = this.dataset.nexts;
    var currents = this.dataset.currents;
    header_steps_style(nexts, 'next');
    style_wrapper_content(
      this.closest('.content_step'),
      current_step,
      nexts,
      currents,
      'next'
    );

    if (this.dataset.currentstep == 'model') {
      document.querySelector('.wrap_swipe_item').style.display = 'block';

      setTimeout(function () {
        document.querySelector('.wrap_swipe_item').style.display = 'none';
      }, 5000);
      var next_slide = this.dataset.nextslide;
      var current_slide = this.dataset.currentslide;
      strap_inner_product(nextstep);
      loading_build_next_buttons(nextstep, next_slide, current_slide);
      loading_destory_slider(current_slide);
      modelSlider(next_slide);
      loading_setup_slider(next_slide, this.dataset.currentstep);
    }
    if (this.dataset.currentstep == 'strap') {
      //document.querySelector('.wrap_swipe_item').style.display = 'block';

      /*  setTimeout(function () {
        document.querySelector('.wrap_swipe_item').style.display = 'none';
      }, 6000); */
      var current_slide = this.dataset.currentslide;
      var wrap_content = document
        .querySelector('.' + nextstep)
        .closest('.content_step');
      wrap_content.querySelector('.prev_step').dataset.currentslide =
        this.dataset.currentslide;
      wrap_content.querySelector('.prev_step').dataset.prevslide =
        this.dataset.currentslide;
      wrap_content.querySelector('.prev_step').dataset.newprevstep =
        this.dataset.prevstep;
      loading_destory_slider(current_slide);
      loading_build_cart(currentModel);
    }
  });
}

function loading_build_cart(datacart) {
  console.log(datacart);
  var add_to_cart_text = document.querySelector('.add_tocart_step_content')
    .dataset.abtn;
  var veiw_button_text = document.querySelector('.add_tocart_step_content')
    .dataset.vbtn;
  var straptype = document.querySelector('.add_tocart_step_content').dataset
    .straptype;

  var price_item = price_element;
  var title_item = `<h1 class="product-info__title h2">${datacart[1]}</h1>`;

  var type_item = `<div class="wrap_bw_type"><strong>${straptype}: </strong><span>${datacart[4]}</span></div>`;

  if (datacart[6]) {
    type_item += `<div class="wrap_bw_view"><span>${datacart[6]}</span></div>`;
  }
  if (datacart[7]) {
    type_item += `<div class="wrap_bw_view"><span>${datacart[7]}</span></div>`;
  }

  var add_to_cart_item = `<div class="product-card__quick-buy">
  <form method="post" action="/cart/add" id="product_form_${datacart[0]}" accept-charset="UTF-8" class="shopify-product-form" enctype="multipart/form-data" is="product-form">
  <input type="hidden" name="form_type" value="product">
  <input type="hidden" name="utf8" value="✓">
  <input type="hidden" name="id" value="${datacart[0]}">
  <input type="hidden" name="properties[${straptype}]" value="${datacart[4]}" />
  <div class="pointer-coarse:hidden">
<button type="submit" class="button" is="custom-button"><div>${add_to_cart_text}</div><span class="button__loader">
<span></span>
<span></span>
<span></span>

</span></button></div></form><a target="_blank" class="viewproduct button" href="${datacart[5]}">${veiw_button_text}</a></div>`;

  document.querySelector(
    '.i_addtcart_content'
  ).innerHTML = `<div class="lwrap_p"><div class="wrap_p_im"><div class="wrap_bw_img"><img src="${datacart[3]}" alt="" /></div></div><div class="wrap_p_con">
  ${title_item}
${type_item}
${price_item}
${add_to_cart_item}
</div></div>`;
}

document.addEventListener('variant:add', function (cart) {
  var cart_item = cart.detail.items[0];
  if (cart_item) {
    var item_properties = cart_item.properties;
    var names = Object.keys(item_properties);
    var name = names[0];

    var values = Object.values(item_properties);
    var value = values[0];
    var popup_cart = document.querySelector('.quick-buy-drawer__info');
    var next_item = popup_cart.querySelector('.justify-self-start');

    var newEle = document.createElement('span');
    newEle.innerHTML = '<strong>' + name + ':</strong>' + value;

    next_item.parentNode.insertBefore(newEle, next_item.nextSibling);
  }
});

function loading_setup_slider(next_slide, current, ptype = null) {
  if (current == 'model') {
    var sldier_wrapper = document
      .querySelector('#' + next_slide)
      .closest('.wrap_strap_product');
  }

  if (current == 'strap') {
    var sldier_wrapper = document
      .querySelector('#' + next_slide)
      .closest('.content_step');
  }
  if (current == 'strap' && ptype == 'addtocart') {
    var sldier_wrapper = document
      .querySelector('#' + next_slide)
      .closest('.wrap_strap_product');
  }

  var title = sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
    .title;
  var subtitle = sldier_wrapper.querySelector('.model_slide:first-of-type')
    .dataset.subtitle;

  if (current == 'model') {
    subtitle +=
      ' | ' +
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.name;
  }
  if (current == 'strap' && ptype == 'addtocart') {
    subtitle +=
      ' | ' +
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.name;
  }
  var image = sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
    .image;

  var current_select_img = sldier_wrapper.querySelector(
    '.current_selection_img img'
  );
  current_select_img.src = image;
  document.querySelector('.builder-subheading').innerText = title;

  var small_item = document.querySelector('.content_step.active');
  small_item.querySelector('.wrap_loading_title_sub h2').innerText = subtitle;

  if (current == 'model') {
    currentModel = [
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .idproduct,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .subtitle,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.price,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.fimage,

      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.name,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .urlproduct,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .metafiled1,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .metafiled2,
    ];

    small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.pdeter;

    price_element = sldier_wrapper.querySelector('.model_slide:first-of-type')
      .dataset.pdeter;
  } else {
    small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.pdeter;
    price_element = sldier_wrapper.querySelector('.model_slide:first-of-type')
      .dataset.pdeter;
    currentModel = [
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .idproduct,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .subtitle,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.price,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset.fimage,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .urlproduct,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .metafiled1,
      sldier_wrapper.querySelector('.model_slide:first-of-type').dataset
        .metafiled2,
    ];
  }
}
function strap_inner_product(item) {
  var all_p_strap = document.querySelectorAll('.wrap_strap_product');
  for (var i = 0; i < all_p_strap.length; i++) {
    all_p_strap[i].style.display = 'none';
    all_p_strap[i].classList.remove('active');
  }
  document.querySelector('.' + item).style.display = 'block';
  document.querySelector('.' + item).classList.add('active');
}

function loading_build_next_buttons(nextstep, next_slide, current_slide) {
  var wrap_content = document
    .querySelector('.' + nextstep)
    .closest('.content_step');
  wrap_content.querySelector('.prev_step').dataset.currentslide = next_slide;
  wrap_content.querySelector('.prev_step').dataset.prevslide = current_slide;
  // wrap_content.querySelector('.prev_step').dataset.prevstep = nextstep;
  wrap_content.querySelector('.next_step').dataset.currentslide = next_slide;
  wrap_content.querySelector('.next_step').dataset.prevstep = nextstep;
  wrap_content.querySelector('.next_step').dataset.nextstep =
    'i_addtcart_content';
}

function style_wrapper_content(
  wrapper,
  current,
  next,
  ptype = null,
  type_step
) {
  if (type_step == 'next') {
    document.querySelector('.builder-heading').innerText =
      document.querySelector('.' + next + '_step_content').dataset.title;

    document.querySelector('.' + current + '_step_content').style.display =
      'none';
    document
      .querySelector('.' + current + '_step_content')
      .classList.remove('active');

    document.querySelector('.' + next + '_step_content').style.display =
      'block';
    document
      .querySelector('.' + next + '_step_content')
      .classList.add('active');
    if (ptype != null) {
      if (next == 'strap') {
        document.querySelector('.' + next + '_content_' + ptype).style.display =
          'block';
        document
          .querySelector('.' + next + '_content_' + ptype)
          .classList.add('active');
      }
    }
  }
  if (type_step == 'prev') {
    document.querySelector('.builder-heading').innerText =
      document.querySelector('.' + next + '_step_content').dataset.title;

    document.querySelector('.' + current + '_step_content').style.display =
      'none';
    document
      .querySelector('.' + current + '_step_content')
      .classList.remove('active');

    if (next == 'spin') {
      document.querySelector('.builder-subheading').innerText =
        document.querySelector('.' + next + '_step_content').dataset.subtitle;
    }

    document.querySelector('.' + next + '_step_content').style.display =
      'block';
    document
      .querySelector('.' + next + '_step_content')
      .classList.add('active');
    if (ptype != null) {
      wrapper.querySelector('div[data-ptype="' + ptype + '"]').style.display =
        'none';
      wrapper
        .querySelector('div[data-ptype="' + ptype + '"]')
        .classList.remove('active');
    }
  }
}

function loading_destory_slider(slider_id) {
  var slider = document.querySelector('#' + slider_id);
  slider.swiper.destroy();
}

function loading_on_slider_change(slider, wrapper) {
  //console.log(slider);
  slider.on('transitionEnd', function () {
    // console.log('trans end');
    setTimeout(function () {
      var title = wrapper.querySelector('.model_slide.swiper-slide-active')
        .dataset.title;
      var subtitle = wrapper.querySelector('.model_slide.swiper-slide-active')
        .dataset.subtitle;

      if (
        wrapper
          .querySelector('.model_slide.swiper-slide-active')
          .classList.contains('strap_slide')
      ) {
        subtitle +=
          ' | ' +
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .name;
      }
      document.querySelector('.builder-subheading').innerText = title;

      var img = wrapper.querySelector('.model_slide.swiper-slide-active')
        .dataset.image;
      var cwrapper = document.querySelector('.model_content.active');

      var current_select_img = cwrapper.querySelector(
        '.current_selection_img img'
      );

      var small_item = document.querySelector('.content_step.active');
      small_item.querySelector('.wrap_loading_title_sub h2').innerText =
        subtitle;

      if (wrapper.classList.contains('strap_step_content')) {
        var wrapper_slider = document.querySelector(
          '.wrap_strap_product.active'
        );
        current_select_img = wrapper_slider.querySelector(
          '.current_selection_img img'
        );
      }
      if (
        wrapper
          .querySelector('.model_slide.swiper-slide-active')
          .classList.contains('strap_slide')
      ) {
        small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
          wrapper.querySelector(
            '.model_slide.swiper-slide-active'
          ).dataset.pdeter;

        price_element = wrapper.querySelector(
          '.model_slide.swiper-slide-active'
        ).dataset.pdeter;

        swierActiveSlide.strap_active = slider.activeIndex;

        currentModel = [
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .idproduct,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .subtitle,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .price,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .fimage,

          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .name,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .urlproduct,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled1,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled2,
        ];
      } else {
        swierActiveSlide.model_active = slider.activeIndex;
        small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
          wrapper.querySelector(
            '.model_slide.swiper-slide-active'
          ).dataset.pdeter;

        price_element = wrapper.querySelector(
          '.model_slide.swiper-slide-active'
        ).dataset.pdeter;

        currentModel = [
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .idproduct,

          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .subtitle,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .price,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .fimage,

          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .urlproduct,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled1,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled2,
        ];
      }

      current_select_img.src = img;

      var nextbutton = wrapper.querySelector('button.next_step');

      if (nextbutton.dataset.currentstep == 'model') {
        nextbutton.setAttribute(
          'data-nextstep',
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .strapstep
        );
        nextbutton.setAttribute(
          'data-nextslide',
          'swiper_' +
            wrapper.querySelector('.model_slide.swiper-slide-active').dataset
              .strapstep +
            '_' +
            wrapper.querySelector('.model_slide.swiper-slide-active').dataset
              .currents
        );
      }
    }, 50);
  });
  slider.on('slideChange', function () {
    console.log('slidechange');
    setTimeout(function () {
      var title = wrapper.querySelector('.model_slide.swiper-slide-active')
        .dataset.title;
      var subtitle = wrapper.querySelector('.model_slide.swiper-slide-active')
        .dataset.subtitle;

      if (
        wrapper
          .querySelector('.model_slide.swiper-slide-active')
          .classList.contains('strap_slide')
      ) {
        subtitle +=
          ' | ' +
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .name;
      }
      document.querySelector('.builder-subheading').innerText = title;

      var img = wrapper.querySelector('.model_slide.swiper-slide-active')
        .dataset.image;
      var cwrapper = document.querySelector('.model_content.active');

      var current_select_img = cwrapper.querySelector(
        '.current_selection_img img'
      );

      var small_item = document.querySelector('.content_step.active');
      small_item.querySelector('.wrap_loading_title_sub h2').innerText =
        subtitle;

      if (wrapper.classList.contains('strap_step_content')) {
        var wrapper_slider = document.querySelector(
          '.wrap_strap_product.active'
        );
        current_select_img = wrapper_slider.querySelector(
          '.current_selection_img img'
        );
      }
      if (
        wrapper
          .querySelector('.model_slide.swiper-slide-active')
          .classList.contains('strap_slide')
      ) {
        small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
          wrapper.querySelector(
            '.model_slide.swiper-slide-active'
          ).dataset.pdeter;

        price_element = wrapper.querySelector(
          '.model_slide.swiper-slide-active'
        ).dataset.pdeter;

        swierActiveSlide.strap_active = slider.activeIndex;

        currentModel = [
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .idproduct,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .subtitle,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .price,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .fimage,

          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .name,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .urlproduct,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled1,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled2,
        ];
      } else {
        swierActiveSlide.model_active = slider.activeIndex;
        price_element = wrapper.querySelector(
          '.model_slide.swiper-slide-active'
        ).dataset.pdeter;

        small_item.querySelector('.wrap_loading_title_sub h6').innerHTML =
          wrapper.querySelector(
            '.model_slide.swiper-slide-active'
          ).dataset.pdeter;

        currentModel = [
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .idproduct,

          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .subtitle,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .price,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .fimage,

          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .urlproduct,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled1,
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .metafiled2,
        ];
      }

      current_select_img.src = img;

      var nextbutton = wrapper.querySelector('button.next_step');

      if (nextbutton.dataset.currentstep == 'model') {
        nextbutton.setAttribute(
          'data-nextstep',
          wrapper.querySelector('.model_slide.swiper-slide-active').dataset
            .strapstep
        );
        nextbutton.setAttribute(
          'data-nextslide',
          'swiper_' +
            wrapper.querySelector('.model_slide.swiper-slide-active').dataset
              .strapstep +
            '_' +
            wrapper.querySelector('.model_slide.swiper-slide-active').dataset
              .currents
        );
      }
    }, 50);
  });
}

function header_steps_style(current_step, type_step) {
 

  if (type_step == 'next') {
    if (current_step == 'strap') {
      document.querySelector('.strap_step').classList.add('active');
      document.querySelector('.progress').style.width = isMobile ? '51.5%' : '59%';
    }
    if (current_step == 'add_tocart') {
      document.querySelector('.add_tocart_step').classList.add('active');
      document.querySelector('.progress').style.width = isMobile ? '83%' : '92%';
    }
  }
  if (type_step == 'prev') {
    if (current_step == 'model') {
      document.querySelector('.model_step').classList.remove('active');
      document.querySelector('.progress').style.width = '0%';
    }
    if (current_step == 'strap') {
      document.querySelector('.strap_step').classList.remove('active');
      document.querySelector('.progress').style.width = isMobile ? '25%' : '30%';
    }
    if (current_step == 'add_tocart') {
      document.querySelector('.add_tocart_step').classList.remove('active');
      document.querySelector('.progress').style.width = isMobile ? '51.5%' : '60.5%';
    }
  }
}